import * as React from 'react'
import Form from '@views/Form/Form'

const ClaimForm = ({ config, content, data }: any) => {
  return <Form config={config} content={content} data={data} />
}

export default ClaimForm
